<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem?.displayName }} [{{ currentItem?.code }}]</h2>
      </div>
      <div class="div-btns-top">
        <action-bar
          [showSave]="manageEnergies && (!currentItem?.resourceId || currentItem?.canUpdate)"
          [showAddToFavorites]="!favoriteId && currentItem && currentItem.resourceId"
          [showRemoveFromFavorites]="favoriteId"
          [showDuplicate]="!!currentItem?.canDuplicate"
          [showDelete]="manageEnergies && !!currentItem?.resourceId && !!currentItem?.canDelete"
          (onSave)="clickSave(form?.value)"
          (onAddToFavorites)="addToFavorite(currentItem.resourceId!)"
          (onRemoveFromFavorites)="removeFromFavorite()"
          (onDuplicate)="clickDuplicate(currentItem.resourceId!)"
          (onDelete)="openDialogDelete(currentItem.resourceId)"></action-bar>
      </div>
    </div>
    <div>
      <div
        [class]="{
          identification: true,
          'disabled-form': !manageEnergies || (!!currentItem?.resourceId && !currentItem?.canUpdate)
        }">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
            <mat-grid-tile colspan="2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="9" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'ref_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" required />
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'ref_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_owner' | translate }}</mat-label>
                <input matInput disabled [value]="currentItem?.owner | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_creator' | translate }}</mat-label>
                <input matInput disabled [value]="currentItem?.creator | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>

      <div class="version col-6" *ngIf="currentItem.resourceId && currentItem.ruade">
        <h3 class="title-margin-top" style="opacity: 0.8">{{ 'ref_section_db_version' | translate }}</h3>
        <!-- <h3 class="title-margin-top">Version de la base de données</h3> -->
        <mat-card>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <mat-label>{{ 'ref_field_choose_version' | translate }}</mat-label>
                <mat-select [multiple]="false" formControlName="versionId" (selectionChange)="onVersionChange($event.value)">
                  <mat-option *ngFor="let p of dbVersions" [value]="p.versionId">
                    {{ p.versionName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div
        [class]="{
          'disabled-form': !manageEnergies || (!!currentItem?.resourceId && !currentItem?.canUpdate)
        }">
        <h3 class="title-margin-top">{{ 'energie_section' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-4">
              <mat-form-field>
                <mat-label>{{ 'common_field_description' | translate }}</mat-label>
                <textarea type="text" formControlName="description" rows="3" matInput></textarea>
              </mat-form-field>
            </div>
            <ng-container *ngIf="energyType === 'vehicle'">
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'energie_field_emission_factor' | translate }}</mat-label>
                  <input matInput formControlName="environmentalFactor" type="number" required />
                  <mat-error *ngIf="formCrls.environmentalFactor.invalid">{{ 'energie_error_emission_factor_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </ng-container>
            <ng-container *ngIf="energyType !== 'vehicle'">
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'energie_field_coefficient_co2' | translate }}</mat-label>
                  <input matInput formControlName="coefficientCO2" type="number" required />
                  <mat-error *ngIf="formCrls.coefficientCO2.invalid">{{ 'energie_error_coefficient_co2_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'energie_field_coefficient_mj' | translate }}</mat-label>
                  <input matInput formControlName="coefficientMJ" type="number" required />
                  <mat-error *ngIf="formCrls.coefficientMJ.invalid">{{ 'energie_error_coefficient_mj_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
          <div class="row">
            <div class="col-3" *ngIf="manageEnergies && (currentItem?.canUpdate || !currentItem?.resourceId)">
              <div class="justificatif" [matTooltip]="!currentItem?.resourceId ? ('ref_save_before_add_proof' | translate) : ''">
                <input id="singleFile" type="file" #proofUpload class="inputfile" accept="application/pdf" (change)="uploadProof(currentItem?.resourceId, proofUpload.files)" #fileInput [disabled]="!currentItem?.resourceId" />
                <button mat-mini-fab color="accent" class="mini-fab" (click)="fileInput.click()" [disabled]="!currentItem?.resourceId">
                  <mat-icon>add</mat-icon>
                </button>
                <label [class.cursor]="currentItem?.resourceId" [attr.for]="currentItem?.resourceId ? 'singleFile' : null">{{ 'ref_add_proof_pdf' | translate }}</label>
              </div>
            </div>
            <div class="col-4" *ngIf="form?.value?.fileName">
              <div class="justificatif">
                <button mat-mini-fab color="warn" class="mini-fab" (click)="deleteFile()" [disabled]="!manageEnergies || !currentItem?.canUpdate">
                  <mat-icon>delete_outline</mat-icon>
                </button>
                <a class="resetPointerEvents" [href]="currentItem?.resourceId ? justificationFilePath + form.value.fileDescription : form.value.fileDescription" target="_blank">{{ form.value.fileName }}</a>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </form>
</div>
